import useSWR from 'swr';
import { fetcherWithToken } from '@/shared/api/fetcher';

type GameLaunchKey = readonly [
  endpoint: 'game',
  gameId: number,
  isDemo: boolean,
];

const fetchGameLaunch = async ([, gameId, isDemo]: GameLaunchKey) => {
  const params = new URLSearchParams({
    id: String(gameId),
    demo: String(isDemo),
  });

  return fetcherWithToken(`/game?${params.toString()}`);
};

export const useGameLaunch = (gameId: number | undefined, isDemo: boolean) =>
  useSWR(gameId ? (['game', gameId, isDemo] as const) : null, fetchGameLaunch);
